import { render } from "./ViewDocument.vue?vue&type=template&id=6c1ec958"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"

import "./ViewDocument.vue?vue&type=style&index=0&id=6c1ec958&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__